export const createFetchSource = (createAbortError) => {
    return async (url) => {
        try {
            const response = await fetch(url);
            if (response.ok) {
                return response.text();
            }
        }
        catch ( /* Ignore errors. */_a) { /* Ignore errors. */ } // tslint:disable-line:no-empty
        throw createAbortError();
    };
};
//# sourceMappingURL=/build/es2018/factories/fetch-source.js.map